import Vue from 'vue'
import Router from 'vue-router'
import { loading } from '@/libraries/nprogress'

Vue.use(Router)

const chunk = require.context('bundle-loader!./pages/', true, /\/index\.vue$/)

function page (path) {
  return () => {
    let loaded = loading()
    return new Promise(function (resolve) {
      chunk(path + '/index.vue')((bundle) => {
        loaded()
        resolve(bundle.default)
      })
    })
  }
}

const routes = [
  { path: '/', component: page('./Home') },
  { path: '/subscribe/success', component: page('./SubscribeSuccess') },
  { path: '*', redirect: '/' },
]

const router = new Router({
  routes,
})

export default router
